module.exports = __webpack_public_path__ + "static/media/laundry-3.e864a1bf.jpg";